import * as yup from 'yup';

export const knowYouBetterSchema = yup.object().shape({
  businessOwnership: yup.string().nullable().required('Please select an option.'),
  taxFilingStatus: yup.string().nullable().required('Please select an option.'),
  dependents: yup.string().nullable().required('Please enter a number.'),
  healthInsuranceStatus: yup.string().nullable().required('Please select an option.'),
  retirementProgram: yup.string().required('Please select an option.'),
  requires1099: yup.string().required('Please select an option.'),
});